"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _scriptHelper = _interopRequireDefault(require("../scriptHelper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initWxCompanyAgentSdk = function initWxCompanyAgentSdk() {
  var configs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    appId: '',
    agentid: '',
    pubHeaders: {},
    success: function success() {
      return null;
    },
    fail: function fail() {
      return null;
    },
    debug: false,
    onError: function onError() {
      return null;
    },
    onFinally: function onFinally() {
      return null;
    },
    jsApiList: []
  };
  var request$getQWConfig = configs.request$getQWConfig,
      request$getQWAgentConfig = configs.request$getQWAgentConfig,
      appId = configs.appId,
      onFinally = configs.onFinally,
      onError = configs.onError,
      debug = configs.debug,
      agentid = configs.agentid,
      _success = configs.success,
      _fail = configs.fail,
      pubHeaders = configs.pubHeaders,
      jsApiList = configs.jsApiList;

  if (!appId) {
    onError('appId不能为空');
    return;
  }

  if (!agentid) {
    onError('agentid不能为空');
    return;
  }

  if (!jsApiList || jsApiList.length === 0) {
    onError('jsApiList不能为空');
    return;
  }

  try {
    _scriptHelper["default"].loadScript('https://res.wx.qq.com/open/js/jweixin-1.2.0.js', (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2() {
      var res1, _res1$data, signature, noncestr, timestamp;

      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return request$getQWConfig({
                agentId: agentid,
                url: encodeURI(window.location.href)
              });

            case 2:
              res1 = _context2.sent;
              res1 = res1.data;

              if (res1.status === 200) {
                _res1$data = res1.data, signature = _res1$data.signature, noncestr = _res1$data.noncestr, timestamp = _res1$data.timestamp;
                wx.config({
                  beta: true,
                  debug: debug,
                  appId: appId,
                  timestamp: timestamp,
                  nonceStr: noncestr,
                  signature: signature,
                  jsApiList: ['getContext'],
                  complete: function complete(ret) {
                    if (debug) {
                      alert(JSON.stringify(ret));
                    }
                  }
                });
                wx.ready(function () {
                  _scriptHelper["default"].loadScript('https://open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js', (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
                    var res, _res$data, _signature, _noncestr, _timestamp, params;

                    return _regenerator["default"].wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return request$getQWAgentConfig({
                              agentId: agentid,
                              url: encodeURI(window.location.href)
                            }, pubHeaders);

                          case 3:
                            res = _context.sent;
                            res = res.data;

                            if (res.status === 200) {
                              _res$data = res.data, _signature = _res$data.signature, _noncestr = _res$data.noncestr, _timestamp = _res$data.timestamp;
                              params = {
                                corpid: appId,
                                agentid: agentid,
                                timestamp: _timestamp,
                                nonceStr: _noncestr,
                                signature: _signature,
                                jsApiList: jsApiList
                              };

                              if (debug) {
                                alert(JSON.stringify(params));
                              }

                              wx.agentConfig(_objectSpread(_objectSpread({}, params), {}, {
                                success: function success(res) {
                                  _success(res);
                                },
                                fail: function fail(res) {
                                  _fail(res);
                                }
                              }));
                            } else {
                              onError(res.err);
                            }

                            _context.next = 11;
                            break;

                          case 8:
                            _context.prev = 8;
                            _context.t0 = _context["catch"](0);
                            onError(_context.t0);

                          case 11:
                            _context.prev = 11;
                            onFinally();
                            return _context.finish(11);

                          case 14:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[0, 8, 11, 14]]);
                  })));
                });
              } else {
                onError(res1.err);
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
  } catch (error) {
    onError(error);
  }
};

var _default = {
  initWxCompanyAgentSdk: initWxCompanyAgentSdk
};
exports["default"] = _default;